<div class="container">
  <app-enea-header></app-enea-header>
  <div class="card mt-5">
    <div class="card-header">
      <app-reservation-header></app-reservation-header>
    </div>
    <div class="card-body">
      <app-reservation-form></app-reservation-form>
    </div>
  </div>
</div>